const NoResults = ({ className, children }) => {
  return (
    <div className={classNames("no-results", className)}>
      { children || "We’re sorry, this menu contains no items." }
    </div>
  )
}

export default NoResults
